import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getMapsTelematicChartData(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TELEMATIC_CHART_DATA,
		options
	)
}

function _getMapsCrops(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS,
		options
	)
}

function _getMapsCropsExtendedInfo(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS_EXTENDED_INFO,
		options
	)
}

function _getMapsEvents(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_EVENTS,
		options
	)
}

// movement points
function _getMapsMovementPoints(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_MOVEMENT_POINTS,
		options
	)
}

function _getMapsTracks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS,
		options
	)
}

function _getMapsTracksExtendedInfo(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_EXTENDED_INFO,
		options
	)
}

function _getMapsTracksMovedMachines(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_MOVED_MACHINES,
		options
	)
}

function _getMapsTracksRealtimeData(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_REALTIME_DATA,
		options
	)
}

function _getMapsFieldWorks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_FIELD_WORKS,
		options
	)
}

function _getMapsLogisticWorks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_LOGISTIC_WORKS,
		options
	)
}

function _getMapsPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_PREVIEW,
		options
	)
}

function _getMachineTrack(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK,
		options
	)
}

function _getRelatedFieldWorks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_RELATED_FIELD_WORKS,
		options
	)
}
function _getMachineWideTrack(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK,
		options
	)
}
function _getMachineWideTrackCrossedCrops(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK_CROSSED_CROPS,
		options
	)
}

function _getMachineTrackPoints(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK_POINTS,
		options
	)
}

function _getSatelliteImageDates(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATES,
		options
	)
}

function _getSatelliteImageDateDynamic(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATE_DYNAMIC,
		options
	)
}

function _getSatelliteImages(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES,
		options
	)
}

function _getSatelliteImage(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE,
		options
	)
}

function _getSatelliteImagesStats(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES_STATS,
		options
	)
}

function _getDoneWorkGeometries(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MAPS,
		ModulesConfigMap[ModulesMap.MAPS].GET_DONE_WORK_GEOMETRIES,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TELEMATIC_CHART_DATA]: _getMapsTelematicChartData,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS]: _getMapsCrops,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS_EXTENDED_INFO]: _getMapsCropsExtendedInfo,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_EVENTS]: _getMapsEvents,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_MOVEMENT_POINTS]: _getMapsMovementPoints,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS]: _getMapsTracks,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_EXTENDED_INFO]: _getMapsTracksExtendedInfo,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_MOVED_MACHINES]: _getMapsTracksMovedMachines,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_REALTIME_DATA]: _getMapsTracksRealtimeData,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_FIELD_WORKS]: _getMapsFieldWorks,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_LOGISTIC_WORKS]: _getMapsLogisticWorks,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_PREVIEW]: _getMapsPreview,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK]: _getMachineTrack,
	[ModulesConfigMap[ModulesMap.MAPS].GET_RELATED_FIELD_WORKS]: _getRelatedFieldWorks,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK]: _getMachineWideTrack,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK_CROSSED_CROPS]: _getMachineWideTrackCrossedCrops,
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK_POINTS]: _getMachineTrackPoints,
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATES]: _getSatelliteImageDates,
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATE_DYNAMIC]: _getSatelliteImageDateDynamic,
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES]: _getSatelliteImages,
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE]: _getSatelliteImage,
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES_STATS]: _getSatelliteImagesStats,
	[ModulesConfigMap[ModulesMap.MAPS].GET_DONE_WORK_GEOMETRIES]: _getDoneWorkGeometries,
}
